import SendIcon from '@mui/icons-material/Send';
import { Box, Button, CircularProgress, Divider, TextField, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { ChatAiAssistTrigger } from './ChatAiAssistDrawer';
import { ChatAiAssistState } from '../../hooks/admin/useChatAiAssist';

interface FidesChatComposeBarProps {
  inputValue: string;
  onInputChange: (value: string) => void;
  onSend: () => void;
  isSending: boolean;
  conversationEnded: boolean;
  openConversationId: string | null;
  liveResolvedBy: string | null | undefined;
  chatAiAssist: ChatAiAssistState;
  hasInvestorMessage: boolean;
}

const FidesChatComposeBar: React.FC<FidesChatComposeBarProps> = ({
  inputValue,
  onInputChange,
  onSend,
  isSending,
  conversationEnded,
  openConversationId,
  liveResolvedBy,
  chatAiAssist,
  hasInvestorMessage,
}) => (
  <>
    <Divider />

    {conversationEnded && (
      <Box
        sx={{
          px: 2,
          py: 1.25,
          backgroundColor: '#f3f4f6',
          borderTop: '1px solid #e5e7eb',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {liveResolvedBy === 'investor'
            ? 'The investor ended this chat. You can still review messages or draft notes.'
            : 'This chat has ended. You can still review messages or draft notes.'}
        </Typography>
      </Box>
    )}

    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'flex-end',
        px: 2,
        py: 1.5,
        backgroundColor: '#fff',
      }}
    >
      <TextField
        multiline
        maxRows={4}
        fullWidth
        value={inputValue}
        onChange={(event) => onInputChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            onSend();
          }
        }}
        placeholder={conversationEnded ? 'Chat ended' : 'Type a message...'}
        disabled={!openConversationId || isSending || conversationEnded}
      />
      <ChatAiAssistTrigger assist={chatAiAssist} lastInvestorMessagePresent={hasInvestorMessage} />
      <Button
        variant="contained"
        onClick={onSend}
        disabled={!inputValue.trim() || !openConversationId || isSending || conversationEnded}
        sx={{
          minWidth: 96,
          height: 40,
          backgroundColor: Palette.default.buttonBg,
        }}
        startIcon={isSending ? <CircularProgress size={16} color="inherit" /> : <SendIcon />}
      >
        Send
      </Button>
    </Box>
  </>
);

export default FidesChatComposeBar;
